/**
 * Shared display names with title (Mr. / Mrs. / Dr. …).
 */

export function normalizeTitle(raw?: string | null): string {
  let title = String(raw ?? "").trim();
  if (!title) return "";
  if (title.endsWith(".")) title = title.slice(0, -1);
  return title.trim();
}

function joinNameParts(...parts: Array<string | null | undefined>): string {
  return parts
    .map((p) => String(p ?? "").trim())
    .filter(Boolean)
    .join(" ")
    .replace(/\s+/g, " ")
    .trim();
}

export function formatPatientDisplayName(patient?: {
  title?: string | null;
  fullName?: string | null;
} | null): string {
  const name = String(patient?.fullName ?? "").trim();
  const title = normalizeTitle(patient?.title);
  if (title && name) return `${title}. ${name}`;
  return name || title;
}

export function formatEmployeeDisplayName(
  employee?: {
    title?: string | null;
    firstName?: string | null;
    lastName?: string | null;
  } | null,
  opts?: { role?: "doctor" | "staff"; defaultDoctorTitle?: string }
): string {
  const role = opts?.role || "doctor";
  const defaultDoctorTitle = opts?.defaultDoctorTitle || "Dr";
  let title = normalizeTitle(employee?.title);
  if (!title && role === "doctor") title = defaultDoctorTitle;
  const name = joinNameParts(employee?.firstName, employee?.lastName);
  if (title && name) return `${title}. ${name}`;
  return name || (title ? `${title}.` : "");
}
